import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { breakpointMobile } from './breakpoints';

/**
 * Spacing settings between types of components
 *
 * Between header and card: `between.card.header`
 * Between cards: `between.card.card`
 * Above section header: `sectionHeader`
 * Above subheading: `subheading`
 * Above title: `title`
 */
export const spacings = (theme: Theme) => {
  const mobile = breakpointMobile(theme);
  const {
    spacing: { unit: spacing },
  } = theme;
  return {
    between: {
      card: {
        card: {
          marginTop: spacing * 2,
          [mobile]: {
            marginTop: spacing * 2,
          },
        },
        header: {
          marginTop: spacing * 3,
          [mobile]: {
            marginTop: spacing * 2,
          },
        },
      },
    },
    paper: {
      padding: spacing * 2,
    },
    page: {
      bottom: {
        marginBottom: spacing * 15, // page bottom margin + footer margin
        [mobile]: {
          marginBottom: spacing * 15, // page bottom margin + footer margin
        },
      },
      top: {
        marginTop: spacing * 6,
        [mobile]: {
          marginTop: spacing * 4,
        },
      },
    },
    sectionHeader: {
      marginTop: spacing * 4,
      [mobile]: {
        marginTop: spacing * 3,
      },
    },
    subheading: {
      marginTop: spacing * 3,
      [mobile]: {
        marginTop: spacing * 2,
      },
    },
    title: {
      marginTop: spacing * 3,
      [mobile]: {
        marginTop: spacing * 2,
      },
    },
    textGroup: {
      marginTop: spacing,
      [mobile]: {
        marginTop: spacing,
      },
    },
  };
};
